// eslint-disable-next-line no-shadow
enum EquipmentHistoryTypes {
    General = 'general',
    Incident = 'incident',
    Modification = 'modification',
    Repair = 'repair',
    System = 'system',
}

export { EquipmentHistoryTypes };
